import React, {
    useCallback, useEffect, useState
} from 'react';
import PropTypes from 'prop-types';

import { Tracking } from 'bdvp-tracking';

import {
    getMediaPath, getShareContentType, getUrlWithParam, getMlbNative, getDeviceInfo,
} from '../../utils';
import {
    useBasePath, usePartnerId,
} from '../../hooks/config';
import FallbackModal from './FallbackModal';

const ShareModal = ({
    isOpen,
    onClosed: onClosedCallback,
    mediaPlayback,
}) => {

    const basePath = useBasePath();
    const [
        isFallbackModalOpen,
        setIsFallbackModalOpen,
    ] = useState(false);
    const onShare = useCallback((type) => Tracking.onShare({
        type,
        contentType: getShareContentType(mediaPlayback),
        slug: mediaPlayback.slug,
        title: mediaPlayback.title,
    }), [mediaPlayback]);
    const onClosed = useCallback(() => {

        Tracking.trackShareModalCloseButtonClick(mediaPlayback.slug);
        onClosedCallback();

    }, [
        mediaPlayback,
        onClosedCallback,
    ]);
    const partnerId = usePartnerId();

    let link = `${__CLIENT__ ? window.location.origin : 'https://www.mlb.com'}${basePath}/${getMediaPath(mediaPlayback)}`;
    link = getUrlWithParam(link, { partnerId });
    const { share: mlbNativeShare } = getMlbNative();
    const { formFactor: deviceFormFactor = 'desktop' } = typeof window !== 'undefined' ? getDeviceInfo() || {} : {};

    useEffect(() => {

        if(!isOpen) {

            setIsFallbackModalOpen(false);
            return;

        }

        const isMobile = deviceFormFactor === 'phone' || deviceFormFactor === 'tablet';

        if(isMobile && window.navigator.share) {

            window.navigator.share({
                title: mediaPlayback.title,
                url: link,
            }).then(() => {

                onShare('NativeShare');
                onClosedCallback();

            })
                .catch((err) => {

                    if (err.name === 'AbortError') {

                        onClosed();
                        return;

                    }

                    setIsFallbackModalOpen(true);

                });

        } else if (isMobile && typeof mlbNativeShare === 'function') {

            mlbNativeShare(link);

        } else {

            setIsFallbackModalOpen(true);

        }

    }, [
        isOpen,
        mediaPlayback,
        link,
        setIsFallbackModalOpen,
        onClosed,
        onClosedCallback,
        onShare,
    ]);

    return <FallbackModal link={link} mediaPlayback={mediaPlayback} isOpen={isFallbackModalOpen} onClosed={onClosed} onShare={onShare} />;

};

ShareModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClosed: PropTypes.func.isRequired,
    mediaPlayback: PropTypes.object,
};

ShareModal.defaultProps = {
    mediaPlayback: {},
};

export default ShareModal;
